import React, { useState } from "react";
import { createContext } from "react";
import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"

export const GeneralContext = createContext();

export function GeneralContextProvider(props) {
  const [user, setUser] = useState()
  const [temas, setTemas] = useState()
  const [configuration, setConfiguration] = useState()
  const [idCuestionarioActual, setIdCuestionarioActual] = useState()
  const [cuestionarioID, setCuestionarioID] = useState()
  const [questionaryPercentage, setQuestionaryPercentage] = useState()
  const [idAxe, setIdAxe] = useState()
  const navigate = useNavigate()
  const { t } = useTranslation()
  const [chartImage, setChartImage] = useState();


  return (
        <GeneralContext.Provider
            value={{
                t,
                user,
                setUser,
                temas,
                setTemas,
                configuration,
                setConfiguration,
                idCuestionarioActual,
                setIdCuestionarioActual,
                questionaryPercentage,
                setQuestionaryPercentage,
                cuestionarioID,
                setCuestionarioID,
                navigate,
                idAxe,
                setIdAxe,
                chartImage,
                setChartImage
            }}
        >
            {props.children}
        </GeneralContext.Provider>
    );
}
